import { render, staticRenderFns } from "./PermissionCategoryDropdown.vue?vue&type=template&id=57005b4c&"
import script from "./PermissionCategoryDropdown.vue?vue&type=script&lang=js&"
export * from "./PermissionCategoryDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports